export const servicios = [

    {
        "descripcion": "Apoyo para el Bienestar y Desarrollo",
        "urlRuts": "https://ruts.hidalgo.gob.mx/ver/10941"
    },
    {
        "descripcion": "Bienestar de Madres Trabajadoras",
        "urlRuts": "https://ruts.hidalgo.gob.mx/ver/11120"
    },
    {
        "descripcion": "Formación con Perspectiva de Discapacidad",
        "urlRuts": "https://ruts.hidalgo.gob.mx/ver/11185"
    },
    {
        "descripcion": "Atención Integral a Personas con Discapacidad",
        "urlRuts": "https://ruts.hidalgo.gob.mx/ver/11186"
    },
    {
        "descripcion": "Interpretación de Lengua de Señas Mexicana",
        "urlRuts": "https://ruts.hidalgo.gob.mx/ver/11217"
    },
    {
        "descripcion": "Bienestar de Personas Cuidadoras de Personas con Discapacidad",
        "urlRuts": "https://ruts.hidalgo.gob.mx/ver/11372"
    },
    {
        "descripcion": "Programa de Subsidio al Servicio de Verificación Vehicular",
        "urlRuts": "https://ruts.hidalgo.gob.mx/ver/11366"
    },
    {
        "descripcion": "Programa de Atención al Pueblo",
        "urlRuts": "https://ruts.hidalgo.gob.mx/ver/11198"
    },
    {
        "descripcion": "Programa de Desarrollo Inclusivo",
        "urlRuts": "https://ruts.hidalgo.gob.mx/ver/11201"
    },
    {
        "descripcion": "Servicios de Información a Actores Sociales, Integrantes de Colectivos Comunitarios",
        "urlRuts": "https://ruts.hidalgo.gob.mx/ver/1625"
    },
    {
        "descripcion": "Registro de Marca",
        "urlRuts": "https://ruts.hidalgo.gob.mx/ver/1185"
    },
    {
        "descripcion": "Asignación de Espacios Eventos y Exposiciones Municipales",
        "urlRuts": "https://ruts.hidalgo.gob.mx/ver/1186"
    },
    {
        "descripcion": "Certificados de Autenticidad de Productos Artesanales",
        "urlRuts": "https://ruts.hidalgo.gob.mx/ver/1189"
    },
    {
        "descripcion": "Asignación de Espacios (Punto de venta HIDARTE)",
        "urlRuts": "https://ruts.hidalgo.gob.mx/ver/1188"
    },
    {
        "descripcion": "Padrón de las Personas Artesanas Hidalguenses",
        "urlRuts": "https://ruts.hidalgo.gob.mx/ver/10926"
    },
    {
        "descripcion": "Reencuentro Familiar \"Raíces Hidalgo\"",
        "urlRuts": "https://ruts.hidalgo.gob.mx/ver/7694"
    },
    {
        "descripcion": "Oficina Itinerante \"Primero el Pueblo, Primero los Migrantes\"",
        "urlRuts": "https://ruts.hidalgo.gob.mx/ver/7697"
    },
    {
        "descripcion": "Traslado de Restos Mortuorios",
        "urlRuts": "https://ruts.hidalgo.gob.mx/ver/959"
    },
    {
        "descripcion": "Invierte en Ti, Invierte en Hidalgo",
        "urlRuts": "https://ruts.hidalgo.gob.mx/ver/11187"
    },
    {
        "descripcion": "Doble Nacionalidad \"Ya Soy Hidalguense\" (Totalmente Gratuito)",
        "urlRuts": "https://ruts.hidalgo.gob.mx/ver/933"
    },
    {
        "descripcion": "Documentos de Viaje Internacional y Asuntos Migratorios (Visas)",
        "urlRuts": "https://ruts.hidalgo.gob.mx/ver/903"
    },
    {
        "descripcion": "Apoyo Económico para Documentos Internacionales",
        "urlRuts": "https://ruts.hidalgo.gob.mx/ver/11367"
    },
    {
        "descripcion": "Apoyo Economico a Personas Migrantes Hidalguenses en Materia de Salud",
        "urlRuts": "https://ruts.hidalgo.gob.mx/ver/11368"
    },
    {
        "descripcion": "Apoyo Económico en el Traslado de Restos",
        "urlRuts": "https://ruts.hidalgo.gob.mx/ver/11369"
    },
    {
        "descripcion": "Apoyo Económico a Migrantes Hidalguenses por Repatriación o Deportación",
        "urlRuts": "https://ruts.hidalgo.gob.mx/ver/11371"
    },
    {
        "descripcion": "Apoyo Económico para Migrantes Hidalguenses por Vulnerabilidad",
        "urlRuts": "https://ruts.hidalgo.gob.mx/ver/11373"
    }
] 